import CollectionList       from "@/js/Shared/Collections/CollectionList";
import KeyboardShortcutItem from "./KeyboardShortcutItem";

export {KeyboardProfileItem as default};

/**
 * Keyboard Profile Item Entity
 *
 * @author      rsimoes <ruben-r-simoes@telecom.pt>
 * @copyright   Copyright (C) Sapo. All rights reserved.
 * @license     Private
 * @since       7.0.0
 */
class KeyboardProfileItem
{
    /**
     * Profile ID
     *
     * An unique identifier for the profile
     *
     * @public
     *
     * @type {String}
     *
     * @since 7.0.0
     */
    name;

    /**
     * Profile Configuration
     *
     * @public
     *
     * @type {Object}
     *
     * @since 7.0.0
     */
    config;

    /**
     * Defines if the profile is enabled
     *
     * @public
     *
     * @type {Boolean}
     *
     * @since 7.0.0
     */
    enabled = true;

    /**
     * Profile Shortcuts list
     *
     * @public
     *
     * @since 7.0.0
     *
     * @type {CollectionList}
     */
    shortcuts = new CollectionList('id');

    /**
     * Creates an adds a shortcut item to the collection
     * for each shortcut declared in the profile configuration
     *
     * @public
     *
     * @param {Object<string, function>} callbacks a list of callbacks to be executed
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    addShortcuts(callbacks) {
        if (!this.config) {
            return;
        }

        for (let [name, action] of Object.entries(this.config)) {
            action.shortcuts.forEach((shortcut) => {
                this.addShortcut(shortcut, action, callbacks[name] || null);
            })
        }
    }

    /**
     * Creates a new shortcut item object and adds it the profile
     *
     * @private
     *
     * @since 7.0.0
     *
     * @param {Object}        shortcut   shortcut metadata
     * @param {string}        shortcut.k shortcut key
     * @param {array<string>} shortcut.m shortcut meta keys (ctrl, shift, alt...)
     * @param {Object}        action     profile action config
     * @param {Function|null} callback   callback to be executed when the shortcut is triggered
     *
     * @return {void}
     */
    addShortcut(shortcut, action, callback) {
        let item      = new KeyboardShortcutItem();
        item.id       = shortcut.k;
        item.key      = shortcut.k;
        item.callback = callback;
        item.delay    = action.delay || 0;

        if (shortcut.m.length) {
            item.id += `+${shortcut.m.join('+')}`;
        }

        this.shortcuts.add(item);
    }
}